export default {
  lastUpdated: 'Last updated: {date}',
  placeholder: 'Placeholder content. Final legal copy pending review.',

  terms: {
    title: 'Terms & Conditions',
    intro:
      'These Terms & Conditions govern your use of GladKey (gladkey.shop). By creating an account or making a purchase, you agree to be bound by these terms.',
    sections: {
      service: {
        heading: '1. Service',
        body: 'GladKey is a marketplace that resells digital game keys sourced from third-party suppliers. Keys are delivered electronically — there is no physical fulfillment.',
      },
      eligibility: {
        heading: '2. Eligibility',
        body: 'You must be at least 16 years old (or the age of majority in your jurisdiction) to use the service.',
      },
      purchase: {
        heading: '3. Purchase & Delivery',
        body: 'Orders are subject to availability and supplier limits. Keys are stored in your account for 24 hours after delivery; please redeem promptly.',
      },
      refunds: {
        heading: '4. Refunds',
        body: 'Refund policy follows applicable consumer law. Once a key is revealed, refunds are generally not available.',
      },
      account: {
        heading: '5. Account & Security',
        body: 'You are responsible for keeping your password secure. Notify us immediately of any unauthorized access.',
      },
      liability: {
        heading: '6. Limitation of Liability',
        body: 'To the maximum extent permitted by law, GladKey is not liable for indirect, incidental, or consequential damages.',
      },
      changes: {
        heading: '7. Changes',
        body: 'We may update these terms. Material changes will be notified by email or in-app.',
      },
      contact: {
        heading: '8. Contact',
        body: 'Questions about these terms? Visit our FAQ or contact support.',
      },
    },
  },

  privacy: {
    title: 'Privacy Policy',
    intro:
      'This Privacy Policy describes how GladKey collects, uses, and protects your personal data when you use gladkey.shop.',
    sections: {
      dataCollected: {
        heading: '1. Data we collect',
        items: [
          'Account data: email, password (hashed), optional profile fields.',
          'Order data: products purchased, prices, key delivery records.',
          'Payment data: handled by our payment provider — we never see your card details.',
          'Technical data: IP address, browser/user-agent (for security & rate-limiting).',
        ],
      },
      howWeUse: {
        heading: '2. How we use it',
        items: [
          'To fulfill your orders and deliver keys.',
          'To prevent fraud and enforce our Terms.',
          'To send transactional emails (verification, receipts, password reset).',
        ],
      },
      sharing: {
        heading: '3. Sharing',
        body: "We share only what's necessary: order details with our key supplier (Kinguin), payment data with our payment provider. We do not sell your data.",
      },
      retention: {
        heading: '4. Retention',
        body: 'Account data is kept for as long as your account exists. Order records may be retained longer for tax and accounting purposes.',
      },
      rights: {
        heading: '5. Your rights',
        body: 'Under GDPR you can request access, correction, or deletion of your personal data. Contact support to exercise these rights.',
      },
      cookies: {
        heading: '6. Cookies',
        linkText: 'Cookie Policy',
        body: 'See our {link} for details on cookies and tracking.',
      },
    },
  },

  cookies: {
    title: 'Cookie Policy & Settings',
    intro:
      'We use cookies and similar technologies to keep the site working, understand usage, and (with your consent) tailor marketing.',
    categories: {
      heading: 'Categories',
      tableHeaders: {
        category: 'Category',
        purpose: 'Purpose',
        examples: 'Examples',
      },
      essential: {
        name: 'Essential',
        purpose: 'Authentication, security, rate-limiting. Always on.',
        examples: 'Session cookie, refresh token',
      },
      analytics: {
        name: 'Analytics',
        purpose: 'Usage statistics — page views and navigation.',
        examples: 'Google Analytics (_ga, _ga_*)',
      },
      marketing: {
        name: 'Marketing',
        purpose: 'Personalized ads and retargeting.',
        examples: 'Google Ads (_gcl_*)',
      },
    },
    preferences: {
      heading: 'Your preferences',
      essential: {
        label: 'Essential',
        description: 'Required for the site to work.',
      },
      analytics: {
        label: 'Analytics',
        description: 'Help us understand how the site is used.',
      },
      marketing: {
        label: 'Marketing',
        description: 'Used for personalized advertising.',
      },
      saved: 'Preferences saved.',
      lastSaved: 'Last saved: {date}',
      notSavedYet: 'No preferences saved yet.',
      saveButton: 'Save preferences',
      storageNote:
        "Preferences are stored in your browser's local storage under {key} — clearing site data will reset them.",
    },
  },
};
